/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SalesCategory = "AIRTIME" | "DATA" | "DSTV" | "ELECTRICITY" | "HOLLYWOOD_BETS" | "LOTTO" | "M2M" | "OTHER" | "RICA_FAILED" | "RICA_SUCCESS" | "RICA_TOTAL" | "TOTAL_SALES" | "UNIPIN" | "%future added value";
export type DashboardSearch_account = {
    readonly categories: ReadonlyArray<{
        readonly category: SalesCategory;
        readonly allZero: boolean;
    }>;
    readonly " $refType": "DashboardSearch_account";
};
export type DashboardSearch_account$data = DashboardSearch_account;
export type DashboardSearch_account$key = {
    readonly " $data"?: DashboardSearch_account$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardSearch_account">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardSearch_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DashboardCategorySales",
      "kind": "LinkedField",
      "name": "categories",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "category",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allZero",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DashboardAccount",
  "abstractKey": "__isDashboardAccount"
};
(node as any).hash = '0e0cc2e784a2dd29896c402b3a78b345';
export default node;
